import React, { useEffect } from 'react'
import { Box, Typography, Grid } from '@mui/material';
import { Tooltip } from '@mui/material';
import OverflowTooltip from '../../helpers/OverflowTooltip';

function Experiance({ employeeData }) {

    return (
        <div>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                    gap: 2,
                    padding: 3,
                    borderRadius: '10px',
                }}
            >
                <Box sx={{ flex: 1 }}>
                    <Grid container spacing={2} >
                        {/* Row 1 */}
                        <Grid container spacing={2} sx={{ marginTop: { xs: '0', sm: "20px" } }}>
                            <Grid item xs={12} sm={4}>
                                <Typography variant="body1" sx={{ color: '#9E9E9E', fontSize: '14px' }}>
                                    Organization Name
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#000001DE', fontSize: '18px' }}><OverflowTooltip>{employeeData?.experience.employer_name || 'N/A'}</OverflowTooltip></Typography>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant="body1" sx={{ color: '#9E9E9E', fontSize: '14px' }}>
                                    Designation
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#000001DE', fontSize: '18px' }}><OverflowTooltip>{employeeData?.experience.designation || 'N/A'}</OverflowTooltip></Typography>
                            </Grid>
                        </Grid>

                        {/* Row 2 */}
                        <Grid container spacing={2} sx={{ marginTop: { xs: '0', sm: "20px" } }}>
                            <Grid item xs={12} sm={4} sx={{ marginTop: { xs: '0', sm: "20px" } }}>
                                <Typography variant="body1" sx={{ color: '#9E9E9E', fontSize: '14px' }}>
                                    From
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#000001DE', fontSize: '18px' }}><OverflowTooltip>{employeeData?.experience.from || 'N/A'}</OverflowTooltip></Typography>
                            </Grid>
                            <Grid item xs={12} sm={4} sx={{ marginTop: { xs: '0', sm: "20px" } }}>
                                <Typography variant="body1" sx={{ color: '#9E9E9E', fontSize: '14px' }}>
                                    To
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#000001DE', fontSize: '18px' }}><OverflowTooltip>{employeeData?.experience.to || 'N/A'}</OverflowTooltip></Typography>
                            </Grid>
                            <Grid item xs={12} sm={4} sx={{ marginTop: { xs: '0', sm: "20px" } }}>
                                <Typography variant="body1" sx={{ color: '#9E9E9E', fontSize: '14px' }}>
                                    Total
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#000001DE', fontSize: '18px' }}><OverflowTooltip>{employeeData?.experience.to || 'N/A'}</OverflowTooltip></Typography>
                            </Grid>
                        </Grid>


                        {/* Row 3 */}
                        <Grid container spacing={2} sx={{ marginTop: { xs: '0', sm: "20px" } }}>
                            <Grid item xs={12} sm={4} sx={{ marginTop: { xs: '0', sm: "20px" } }}>
                                <Typography variant="body1" sx={{ color: '#9E9E9E', fontSize: '14px' }}>
                                    Experience Letter
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#000001DE', fontSize: '18px' }}>{employeeData?.experience.exp_letter || 'N/A'}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={4} sx={{ marginTop: { xs: '0', sm: "20px" } }}>
                                <Typography variant="body1" sx={{ color: '#9E9E9E', fontSize: '14px' }}>
                                    Last 3 Month Payslip
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#000001DE', fontSize: '18px' }}>{employeeData?.experience.payslip_filename || 'N/A'}</Typography>
                            </Grid>
                        </Grid>

                    </Grid>
                </Box>
            </Box>
        </div>
    )
}

export default Experiance